import React from 'react';
import './styles.css';

const PaginacaoCustomizada = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  showFirstLast = true,
  maxVisiblePages = 5 
}) => {
  if (totalPages <= 1) return null;

  const getVisiblePages = () => {
    const pages = [];
    const half = Math.floor(maxVisiblePages / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, start + maxVisiblePages - 1);

    if (end - start + 1 < maxVisiblePages) {
      start = Math.max(1, end - maxVisiblePages + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const visiblePages = getVisiblePages();
  const showFirstEllipsis = visiblePages[0] > 2;
  const showLastEllipsis = visiblePages[visiblePages.length - 1] < totalPages - 1;

  return (
    <div className="paginacao-customizada">
      <div className="paginacao-container">
        {showFirstLast && currentPage > 1 && (
          <button
            className="paginacao-btn paginacao-btn-first"
            onClick={() => onPageChange(1)}
            title="Primeira página"
          >
            <span>««</span>
          </button>
        )}

        {currentPage > 1 && (
          <button
            className="paginacao-btn paginacao-btn-prev"
            onClick={() => onPageChange(currentPage - 1)}
            title="Página anterior"
          >
            <span>‹</span>
          </button>
        )}

        {showFirstEllipsis && (
          <>
            <button
              className="paginacao-btn paginacao-btn-number"
              onClick={() => onPageChange(1)}
            >
              1
            </button>
            <span className="paginacao-ellipsis">...</span>
          </>
        )}

        {visiblePages.map((page) => (
          <button
            key={page}
            className={`paginacao-btn paginacao-btn-number ${
              page === currentPage ? 'paginacao-btn-active' : ''
            }`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}

        {showLastEllipsis && (
          <>
            <span className="paginacao-ellipsis">...</span>
            <button
              className="paginacao-btn paginacao-btn-number"
              onClick={() => onPageChange(totalPages)}
            >
              {totalPages}
            </button>
          </>
        )}

        {currentPage < totalPages && (
          <button
            className="paginacao-btn paginacao-btn-next"
            onClick={() => onPageChange(currentPage + 1)}
            title="Próxima página"
          >
            <span>›</span>
          </button>
        )}

        {showFirstLast && currentPage < totalPages && (
          <button
            className="paginacao-btn paginacao-btn-last"
            onClick={() => onPageChange(totalPages)}
            title="Última página"
          >
            <span>»»</span>
          </button>
        )}
      </div>

      <div className="paginacao-info">
        Página {currentPage} de {totalPages}
      </div>
    </div>
  );
};

export default PaginacaoCustomizada;
